<!-- Installation invoice form -->
<div class="invoice-child" [ngClass]="theme.getThemeClass()">
  @if (isBusy) {
    <div class="invoice-loading-overlay">
      <div class="loading-inline">{{ "loading" | translate }}</div>
    </div>
  }
  <h5 class="invoice-title">
    {{ "invoiceGeneration.installation" | translate }}
  </h5>

  <!-- Invoice fields -->
  <div class="invoice-fields">
    <app-invoice-device-count-info
      [deviceCount]="deviceCount"
      [devices]="selectedDeviceDetails"
    ></app-invoice-device-count-info>

    <div class="form-group">
      <!-- Per-device installation fee -->
      <label class="form-label">{{ "costEdit.deviceFee" | translate }}</label>
      <div class="input-group">
        <span class="input-group-text">$</span>
        <input
          class="form-control"
          type="text"
          [(ngModel)]="deviceFee"
          (input)="feeInput.onInput($event)"
          (keydown)="feeInput.onKeydown($event)"
          (paste)="feeInput.onPaste($event)"
          (blur)="deviceFee = feeInput.formatFeeValue(deviceFee)"
        />
      </div>
    </div>

    <div class="form-group">
      <!-- Additional fee (optional) -->
      <label class="form-label">{{
        "costEdit.additionalFee" | translate
      }}</label>
      <div class="input-group">
        <span class="input-group-text">$</span>
        <input
          class="form-control"
          type="text"
          [(ngModel)]="additionalFee"
          (input)="feeInput.onInput($event)"
          (keydown)="feeInput.onKeydown($event)"
          (paste)="feeInput.onPaste($event)"
          (blur)="additionalFee = feeInput.formatFeeValue(additionalFee)"
        />
      </div>
    </div>
    <!-- PDF generation action -->
    <div class="actions">
      <div class="actions-inner">
        <button
          class="btn btn-dropdown fixed-size"
          type="button"
          [disabled]="!canGenerate"
          (click)="generateInvoicePdf()"
        >
          {{ "invoiceGeneration.generate" | translate }}
        </button>
      </div>
    </div>
  </div>

</div>
